import { useQuery } from '../../../ReactQuery';
import { get } from '../../../redux/api';
import type { GetOrganizationResponse } from '../../../../shared/organizationV2';

/**
 * Fetches the organization that the authenticated user belongs to.
 */
export default function useOrganization() {
  return useQuery({
    queryKey: ['organizationV2'],
    queryFn: () => get<GetOrganizationResponse>('/api/v2/organization'),
  });
}
